export default __webpack_public_path__ + "static/assets/e29ee33450ae6c8b86b78d4d58150ea0.png";